/** System default station image — used as the ultimate fallback when no station/show/episode image is available. */
export const DEFAULT_STATION_IMAGE = '/default-station.svg';
